import { createSelector } from 'reselect'

const getBreakpoints = state => state.interactiveVideoCreation.media.breakpoints

const breakpointsSelector = createSelector(
	[ getBreakpoints ],
	breakpoints => breakpoints
)

export default breakpointsSelector
